import * as yup from "yup";

export default yup.object().shape({
  first_name: yup.string().required().label("First Name"),
  last_name: yup.string().required().label("Last Name"),
  email: yup.string().email().required().label("Email"),
  profile_image_url: yup.string().url().label("Profile Image URL").notRequired().nullable(),
  is_active: yup.boolean().notRequired().default(true).label("Active"),
  role_name: yup.string().notRequired().oneOf(["Deployment", "Internal", "Organization"]).default('Organization').label("Role Name"),
});